import styles from './DealStatusLayout.module.scss';

type DealerStatusLayoutProps = {
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
};

const DealStatusLayout = ({ leftContent, rightContent }: DealerStatusLayoutProps) => {
  return (
    <div className={styles.dealStatus__layout}>
      <div className={styles.dealStatus__left}>{leftContent}</div>
      <div className={styles.dealStatus__right}>{rightContent}</div>
    </div>
  );
};

export default DealStatusLayout;
